import { jsx as _jsx } from "react/jsx-runtime";
import closeIcon from 'assets/icons/Header/icon-close.svg';
import scss from './CloseDrawerButton.module.scss';
const close = `${closeIcon}#close`;
const CloseIcon = () => (_jsx("svg", Object.assign({ className: scss.closeDrawerIcon, "aria-hidden": true }, { children: _jsx("use", { href: close }) })));
export const CloseDrawerButton = ({ closeDrawer }) => (_jsx("button", Object.assign({ className: scss.closeDrawerButton, onClick: closeDrawer, "aria-label": "close" }, { children: _jsx(CloseIcon, {}) })));
